import Vue from 'vue';
import Router from 'vue-router';
import store from './store';

import Login from './routes/Login/Login.vue';
import Signup from './routes/Login/Signup.vue';
import ResetPassword from './routes/resetpassword.vue';
import Dashboard from './routes/Dashboard/Index.vue';
import Broadcast from './routes/Broadcast/Index.vue';
import BroadcastGeneral from './routes/Broadcast/General.vue';
import BroadcastCenter from './routes/Broadcast/Controlcenter.vue';
import BroadcastCommerce from './routes/Broadcast/Commerce.vue';
import BroadcastStats from './routes/Broadcast/Stats.vue';
import BroadcastQA from './routes/Broadcast/QA.vue';
import BroadcastsNew from './routes/Broadcasts/Index.vue';
import BroadcastsList from './routes/Broadcasts/List.vue';
import BroadcastsType from './routes/Broadcasts/Type.vue';
import Customers from './routes/Customers/Index.vue';
import Customer from './routes/Customers/Customer.vue';
import AllCustomers from './routes/Customers/AllCustomers.vue';
import CustomerForms from './routes/Customers/CustomerForms.vue';
import CustomerGiveaways from './routes/Customers/CustomerGiveaways.vue';
import CustomerForm from './routes/Customers/CustomerForm.vue';
import CustomerGiveaway from './routes/Customers/CustomerGiveaway.vue';
import Video from './routes/Videos/Video.vue';
import VideoCenter from './routes/Videos/Center.vue';
import VideoSettings from './routes/Videos/Settings.vue';
import VideoCommerce from './routes/Videos/Commerce.vue';
import VideoStatistics from './routes/Videos/Statistics.vue';
import Commerce from './routes/Commerce/Index.vue';
import CommerceTransaction from './routes/Commerce/Transaction.vue';
import CommerceTransactions from './routes/Commerce/Transactions.vue';
import CommerceReports from './routes/commerce-reports.vue';
import CommercePayouts from './routes/commerce-payouts.vue';
// import CommerceOrders from './routes/commerce-orders.vue';
import CommerceDonations from './routes/Commerce/Donations.vue';
import Payout from './routes/payout.vue';
import Collection from './routes/Collection/Index.vue';
import Collections from './routes/Collections/Index.vue';
import Settings from './routes/Settings/Index.vue';
import SettingsAccount from './routes/Settings/AccountDetails.vue';
import SettingsUsers from './routes/Settings/Users.vue';
import SettingsSubAccounts from './routes/Settings/ConnectedAccounts.vue';
import SettingsStreams from './routes/Settings/Streams.vue';
import SettingsLiveshopping from './routes/Settings/Liveshopping.vue';
import SettingsPayout from './routes/Settings/Payout.vue';
import SettingsPlan from './routes/Settings/Plan.vue';
import SettingsBilling from './routes/Settings/PlanSubscription.vue';
import OauthShopify from './routes/oauth-shopify.vue';
import OauthShopline from './routes/Oauth/shopline.vue';
import OauthShoplineConsent from './routes/Oauth/shopline-consent.vue';
import Developer from './routes/Developer/Index.vue';
import DeveloperLogs from './routes/Developer/Logs.vue';
import DeveloperLog from './routes/Developer/Log.vue';
import Videos from './routes/Videos/Index.vue';
import Products from './routes/Products/Index.vue';
import Tickets from './routes/Products/Tickets.vue';
import TicketsAdd from './routes/Products/TicketsAdd.vue';
import Product from './routes/Product/Index.vue';
import Appearance from './routes/Appearance/Index.vue';
import AppearanceChoice from './routes/Appearance/Choice.vue';
import AppearancePlay from './routes/Appearance/Play.vue';
import AppearanceLVSP from './routes/Appearance/Lvsp.vue';
import AppearanceLiveshopping from './routes/Appearance/Liveshopping.vue';
import AppearanceTranslations from './routes/Appearance/Translations.vue';
import Statistics from './routes/Statistics/Index.vue';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

const routes = [
  /**
   * This should cover / and * that isn't added to the list
   */
  {
    path: '*',
    redirect: '/dashboard',
  },
  /**
   * Login/Signup/Reset/Forgot password
   */
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/signup',
    name: 'signup',
    component: Signup,
  },
  {
    path: '/resetpassword',
    name: 'resetpassword',
    props: true,
    component: ResetPassword,
    children: [
      {
        path: '/resetpassword/:token',
        component: ResetPassword,
        name: 'resetpassword2',
      },
    ],
  },
  /**
   * Dashboard
   */
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      permission: [1, 6, 12, 15, 16],
      private: true,
      name: 'dashboard',
      menu: {
        icon: 'dashboard-24',
        i18n: 'dashboard.title',
        highlight: ['dashboard'],
        primary: true,
        order: 0,
      },
    },
    component: Dashboard,
  },
  /**
   * Broadcasts
   */
  {
    path: '/broadcasts',
    name: 'broadcasts',
    // alias: ['/broadcasts/upcoming', '/broadcasts/past', '/broadcasts/all'],
    component: BroadcastsNew,
    children: [
      {
        path: '/broadcasts',
        component: BroadcastsList,
        meta: {
          path: '/broadcasts',
          name: 'broadcast',
          permission: [1, 6, 12, 15, 16],
        },
      },
      {
        path: '/broadcasts/:type',
        component: BroadcastsType,
        props: true,
        meta: {
          path: '/broadcasts/:type',
          name: 'broadcast',
          permission: [1, 6, 12, 15, 16],
        },
      },
    ],
    meta: {
      permission: [1, 6, 12, 15, 16],
      private: true,
      name: 'broadcasts',
      menu: {
        primary: true,
        order: 1,
        icon: 'stream-24',
        i18n: 'broadcast.title',
        highlight: ['broadcasts', 'broadcast', 'upcoming', 'past', 'all', 'schedule'],
        /*
        items: [
          {
            permission: [1, 6, 12, 15, 16],
            to: '/broadcasts/upcoming',
            i18n: 'library.upcoming',
            highlight: ['upcoming'],
          },
          {
            permission: [1, 6, 12, 15, 16],
            to: '/broadcasts/past',
            i18n: 'library.past',
            highlight: ['past'],
          },
          {
            permission: [1, 6, 12, 15, 16],
            to: '/broadcasts/all',
            i18n: 'library.all',
            highlight: ['all'],
          },
        ],
        */
      },
    },
  },
  {
    path: '/broadcast/:id',
    name: '',
    component: Broadcast,
    props: true,
    meta: {
      permission: [1, 6, 12, 15, 16],
      private: true,
      name: 'broadcast',
    },
    children: [
      {
        path: '',
        component: BroadcastCenter,
      },
      {
        path: 'settings',
        component: BroadcastGeneral,
      },
      /*
      {
        path: 'settings',
        component: BroadcastSettings,
      },
      */
      /*
      {
        path: 'chat',
        component: BroadcastChat,
      },
      {
        path: 'products',
        component: BroadcastProducts,
      },
      */
      {
        path: 'qa',
        component: BroadcastQA,
      },
      {
        path: 'statistics',
        component: BroadcastStats,
      },
      {
        path: 'commerce',
        component: BroadcastCommerce,
      },
    ],
  },
  /**
   * Videos
   */
  {
    path: '/videos',
    props: true,
    name: 'videos',
    component: Videos,
    meta: {
      permission: [1, 6, 15, 16],
      private: true,
      name: 'videos',
      menu: {
        primary: true,
        order: 2,
        icon: 'video',
        i18n: 'video.title',
        highlight: ['videos', 'video'],
      },
    },
    /*
    children: [
      {
        path: '/videos',
        component: VideosList,
        meta: {
          path: '/videos',
          name: 'videos',
          permission: [1, 6, 12, 15, 16],
        },
      },
    ],
    */
  },
  {
    path: '/video/:id',
    name: '',
    component: Video,
    props: true,
    meta: {
      permission: [1, 6, 12, 15, 16],
      private: true,
      name: 'video',
    },
    children: [
      {
        path: '',
        component: VideoCenter,
        meta: {
          name: 'video',
        },
      },
      {
        path: 'settings',
        component: VideoSettings,
        meta: {
          name: 'video',
        },
      },
      {
        path: 'commerce',
        component: VideoCommerce,
        meta: {
          name: 'video',
        },
      },
      {
        path: 'statistics',
        component: VideoStatistics,
        meta: {
          name: 'video',
        },
      },
    ],
  },
  /**
   * Collections
   */
  {
    path: '/collections',
    name: 'collections',
    component: Collections,
    meta: {
      permission: [1, 6, 15, 16],
      private: true,
      name: 'collections',
      conditions: [
        {
          field: 'featuresEnabled',
          type: 'contains',
          value: 'ppv',
        },
      ],
      menu: {
        primary: true,
        order: 3,
        icon: 'stacked',
        i18n: 'collections.title',
        highlight: ['collections', 'collection'],
      },
    },
  },
  {
    path: '/collection/:id',
    name: 'collection',
    props: true,
    component: Collection,
    meta: {
      permission: [1, 6, 15, 16],
      private: true,
      name: 'collection',
    },
  },
  {
    path: '/customers',
    name: 'customers',
    component: Customers,
    meta: {
      permission: [1, 6, 15, 16],
      private: true,
      name: 'customers',
      conditions: [
        {
          field: 'featuresEnabled',
          type: 'contains',
          value: 'lvs',
        },
      ],
      menu: {
        primary: true,
        order: 4,
        icon: 'users-24',
        title: 'Customers',
        highlight: ['customers', 'customer', 'customer-giveaway', 'customer-form', 'form'],
      },
    },
    children: [
      {
        path: '/customers',
        component: AllCustomers,
        meta: {
          path: '/customers',
          name: 'customers',
        },
      },
      {
        path: '/customers/giveaway',
        component: CustomerGiveaways,
        meta: {
          path: '',
          name: 'customer-giveaway',
        },
      },
      {
        path: '/customers/form',
        component: CustomerForms,
        meta: {
          path: '',
          name: 'customer-form',
        },
      },
    ],
  },
  {
    path: '/customer/:id',
    name: 'customer',
    props: true,
    component: Customer,
    meta: {
      permission: [1, 6, 15, 16],
      private: true,
      name: 'customer',
    },
  },
  {
    path: '/form/:id',
    name: 'form',
    props: true,
    component: CustomerForm,
    meta: {
      permission: [1, 6, 15, 16],
      private: true,
      name: 'form',
    },
  },
  {
    path: '/giveaway/:id',
    name: 'giveaway',
    props: true,
    component: CustomerGiveaway,
    meta: {
      permission: [1, 6, 15, 16],
      private: true,
      name: 'giveaway',
    },
  },
  /**
   * Products
   */
  {
    path: '/tickets',
    name: 'tickets',
    component: Products,
    meta: {
      permission: [1, 6, 15, 16],
      private: true,
      name: 'products',
      conditions: [
        {
          field: 'featuresEnabled',
          type: 'contains',
          value: 'ppv',
        },
      ],
      menu: {
        primary: true,
        order: 4,
        icon: 'tshirt-product-24',
        i18n: 'commerce.tickets',
        highlight: ['products', 'tickets', 'ticket', 'tickets-add'],
      },
    },
    children: [
      {
        path: '/tickets',
        component: Tickets,
        meta: {
          path: '/tickets',
          name: 'products',
        },
        alias: ['tickets'],
      },
      {
        path: '/tickets/add',
        component: TicketsAdd,
        meta: {
          path: '',
          name: 'tickets-add',
        },
      },
    ],
  },
  /*
  {
    path: '/products',
    name: 'products',
    component: Products,
    meta: {
      permission: [1, 6, 15, 16],
      private: true,
      name: 'products',
      conditions: [
        {
          field: 'featuresEnabled',
          type: 'contains',
          value: 'ppv',
        },
      ],
      menu: {
        primary: true,
        order: 4,
        icon: 'tshirt',
        i18n: 'products.title',
        highlight: ['products-list', 'products-add', 'products', 'product'],
        items: [
          {
            permission: [1, 6, 12, 15, 16],
            to: '/products/stream',
            i18n: 'products.stream_list_title',
            highlight: ['tickets-list'],
          },
          {
            permission: [1, 6, 12, 15, 16],
            to: '/products/good',
            i18n: 'products.good_list_title',
            highlight: ['products-list'],
            disabledCondition: {
              value: 'liveshoppingEnabled',
              is: true,
            },
          },
          //{
          //  permission: [1, 6, 12, 15],
          //  to: '/products/service',
          //  disabled: true,
          //  i18n: 'products.service_list_title',
          //  highlight: ['services-list'],
          //},
          {
            permission: [1, 6, 15, 16],
            to: '/products/add',
            i18n: 'products.add_product',
            icon: 'mdi-plus',
            highlight: ['products-add'],
          },
        ],
      },
    },
    children: [
      {
        path: '/products',
        component: ProductsList,
        meta: {
          path: '',
          name: 'products',
        },
        alias: ['/products/stream', '/products/good', '/products/service'],
      },
      {
        path: '/products/add',
        component: ProductsAdd,
        meta: {
          path: '',
          name: 'products-add',
        },
      },
      {
        path: '/products/add/:type',
        component: ProductsAddNew,
        props: true,
        meta: {
          path: '',
          name: 'products-add',
        },
      },
    ],
  },
  */
  /**
   * Ticket
   */
  {
    path: '/ticket/:id',
    props: true,
    name: 'ticket',
    meta: {
      permission: [1, 6, 15, 16],
      private: true,
      name: 'ticket',
    },
    component: Product,
  },
  /**
   * Commerce
   */
  {
    path: '/commerce',
    name: 'commerce',
    component: Commerce,
    meta: {
      permission: [1, 6, 15, 16],
      private: true,
      name: 'commerce',
      conditions: [
        {
          field: 'featuresEnabled',
          type: 'contains',
          value: 'ppv',
        },
      ],
      menu: {
        primary: false,
        order: 0,
        icon: 'dollar-24',
        i18n: 'commerce.title',
        highlight: [
          'commerce',
          'commerce-orders',
          'commerce-tickets',
          'commerce-transactions',
          'commerce-reports',
          'commerce-donations',
          'commerce-payouts',
          'donations',
          'payouts',
        ],
        items: [
          {
            permission: [1, 6, 15, 16],
            to: '/commerce',
            i18n: 'commerce.transactions',
            highlight: ['commerce-transactions'],
          },
          {
            permission: [1, 6, 15, 16],
            to: '/commerce/orders',
            i18n: 'products.orders',
            highlight: ['commerce-orders'],
          },
          {
            permission: [1, 6, 15, 16],
            to: '/commerce/donations',
            i18n: 'donations.donations',
            icon: 'mdi-heart-outline',
            statusDisable: 'incomplete',
            highlight: ['donations'],
          },
          {
            permission: [1, 6, 15, 16],
            to: '/commerce/reports',
            i18n: 'commerce.reports',
            highlight: ['commerce-reports'],
          },
          {
            permission: [1, 6, 15, 16],
            to: '/commerce/payouts',
            i18n: 'commerce.payouts',
            highlight: ['commerce-payouts', 'payouts'],
          },
        ],
      },
    },
    children: [
      {
        path: '/commerce',
        component: CommerceTransactions,
        meta: {
          path: 'transactions',
          name: 'commerce-transactions',
        },
      },
      /*
      {
        path: '/commerce/orders',
        component: CommerceOrders,
        meta: {
          path: 'orders',
          name: 'commerce-orders',
        },
      },
      */
      {
        path: '/commerce/donations',
        component: CommerceDonations,
        meta: {
          permission: [1, 6, 15, 16],
          path: 'donations',
          name: 'donations',
        },
      },
      {
        path: 'reports',
        component: CommerceReports,
        meta: {
          path: 'reports',
          name: 'commerce-reports',
        },
      },
      {
        path: 'payouts',
        component: CommercePayouts,
        meta: {
          path: 'payouts',
          name: 'commerce-payouts',
        },
      },
    ],
  },
  {
    path: '/transaction/:id',
    name: 'transaction',
    props: true,
    component: CommerceTransaction,
    meta: {
      permission: [1, 6, 15, 16],
      private: true,
      name: 'transaction',
    },
  },
  {
    path: '/payouts/:id',
    name: 'payouts',
    props: true,
    meta: {
      permission: [1, 6, 15, 16],
      private: true,
      name: 'payouts',
    },
    component: Payout,
    children: [
      {
        path: '/payouts/:id',
        component: Payout,
        meta: {
          path: '',
          name: 'payouts',
          permission: [1, 6, 15, 16],
        },
      },
    ],
  },
  {
    path: '/statistics',
    name: 'statistics',
    meta: {
      permission: [1, 6, 15, 16],
      private: true,
      name: 'statistics',
      menu: {
        icon: 'line-graph-24',
        i18n: 'statistics.title',
        highlight: ['statistics'],
        primary: true,
        order: 5,
      },
    },
    component: Statistics,
  },
  /**
   * Ticket
   *
  {
    path: '/ticket/:id',
    props: true,
    name: 'ticket',
    meta: {
      permission: [1, 6, 15, 16],
      private: true,
      name: 'ticket',
    },
    component: Ticket,
    children: [
      {
        path: '/ticket/:id',
        component: TicketOverview,
        meta: {
          path: '',
          name: 'ticket',
        },
      },
      {
        path: 'templates',
        component: TicketTemplates,
        meta: {
          path: 'templates',
          name: 'ticket',
        },
      },
    ],
  },
  */
  {
    path: '/appearance/lvsp/:broadcast?',
    name: 'lvsp',
    meta: {
      permission: [1, 6, 15, 16],
      private: true,
      path: 'lvsp',
      name: 'lvsp',
    },
    component: AppearanceLVSP,
  },
  {
    path: '/appearance/liveshopping/:broadcast?',
    name: 'liveshopping',
    meta: {
      permission: [1, 6, 15, 16],
      private: true,
      path: 'liveshopping',
      name: 'liveshopping',
    },
    component: AppearanceLiveshopping,
  },
  {
    path: '/appearance',
    name: 'appearance',
    component: Appearance,
    children: [
      {
        path: '/appearance',
        component: AppearanceChoice,
        meta: {
          path: '/appearance',
          name: 'choice',
        },
      },
      {
        path: '/appearance/play',
        component: AppearancePlay,
        meta: {
          path: '/appearance/play',
          name: 'lvsp',
        },
      },
      {
        path: '/appearance/lvsp',
        component: AppearanceLVSP,
        meta: {
          path: '/appearance/lvsp',
          name: 'lvsp',
        },
      },
      {
        path: '/appearance/translations',
        component: AppearanceTranslations,
        alias: ['/appearance/translations', '/appearance/translations/chat-qa', '/appearance/translations/giveaway', '/appearance/translations/form', '/appearance/translations/products', '/appearance/translations/poster', '/appearance/translations/common'],
        meta: {
          path: '/appearance/translations',
          name: 'lvsp',
        },
      },
    ],
    meta: {
      permission: [1, 6, 15, 16],
      private: true,
      name: 'appearance',
      menu: {
        i18n: 'appearance.title',
        icon: 'brush-24',
        highlight: ['appearance', 'play-site', 'lvsp'],
        primary: false,
        order: 2,
        items: [
          {
            permission: [1, 6, 15, 16],
            to: '/appearance',
            i18n: 'appearance.play_site',
            icon: 'mdi-video',
            highlight: ['play-site'],
            conditions: [
              {
                field: 'featuresEnabled',
                type: 'contains',
                value: 'ppv',
              },
            ],
          },
          {
            permission: [1, 6, 15, 16],
            to: '/appearance/lvsp',
            i18n: 'appearance.lvsp',
            icon: 'mdi-shopping-music',
            highlight: ['lvsp'],
            conditions: [
              {
                field: 'featuresEnabled',
                type: 'contains',
                value: 'lvs',
              },
            ],
          },
        ],
      },
    },
  },
  /**
   * Settings
   */
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    meta: {
      permission: [1, 6, 15, 16],
      private: true,
      name: 'settings',
      menu: {
        primary: false,
        order: 3,
        i18n: 'settings.title',
        icon: 'settings-gear-24',
        highlight: [
          'settings',
          'connected-accounts',
          'settingsaccount',
          'settingsuser',
          'streams',
          'users',
          'liveshopping',
          'payout',
          'plan',
          'billing',
        ],
        items: [
          /*
          {
            permission: [1, 6, 12, 15],
            to: '/settings',
            i18n: 'settings.user_settings',
            icon: 'account',
            highlight: ['settingsuser'],
          },
          */
          {
            permission: [1, 6, 15, 16],
            to: '/settings',
            i18n: 'settings.account',
            icon: 'mdi-steering',
            highlight: ['settingsaccount'],
          },
          {
            permission: [1, 6, 15, 16],
            to: '/settings/connected-accounts',
            i18n: 'settings.connected-accounts',
            icon: 'mdi-account-child',
            highlight: ['connected-accounts'],
          },
          {
            permission: [1, 6, 15, 16],
            to: '/settings/plan',
            i18n: 'settings.plan.title',
            icon: 'mdi-credit-card',
            highlight: ['plan'],
            /*
            condition: {
              value: 'activeSubscription',
              is: false,
            },
            */
            conditions: [
              {
                field: 'activeSubscription',
                type: 'is',
                value: false,
              },
            ],
          },
          {
            permission: [1, 6, 15, 16],
            to: '/settings/billing',
            i18n: 'settings.plan.billing',
            icon: 'mdi-credit-card',
            highlight: ['billing'],
            /*
            condition: {
              value: 'activeSubscription',
              is: true,
            },
            */
            conditions: [
              {
                field: 'activeSubscription',
                type: 'is',
                value: true,
              },
            ],
          },
          {
            permission: [1, 6, 15, 16],
            to: '/settings/liveshopping',
            i18n: 'settings.liveshopping.title',
            icon: 'mdi-tune',
            highlight: ['liveshopping'],
            conditions: [
              {
                field: 'featuresEnabled',
                type: 'contains',
                value: 'lvs',
              },
            ],
          },
          {
            permission: [1, 6, 15, 16],
            to: '/settings/payout',
            i18n: 'settings.payout',
            icon: 'mdi-bank',
            highlight: ['payout'],
            conditions: [
              {
                field: 'featuresEnabled',
                type: 'contains',
                value: 'ppv',
              },
            ],
          },
          {
            permission: [1, 6, 15, 16],
            to: '/settings/users',
            i18n: 'settings.users',
            icon: 'account-group',
            highlight: ['users'],
          },
          {
            permission: [1, 6, 15, 16],
            to: '/settings/streams',
            i18n: 'settings.streams',
            icon: 'mdi-tune',
            highlight: ['streams'],
          },
        ],
      },
    },
    children: [
      {
        path: '/settings',
        component: SettingsAccount,
        meta: {
          permission: [1, 6, 15, 16],
          path: '',
          name: 'settingsaccount',
        },
      },
      {
        path: '/settings/users',
        component: SettingsUsers,
        meta: {
          permission: [1, 6, 15, 16],
          path: 'users',
          name: 'users',
        },
      },
      {
        path: '/settings/connected-accounts',
        component: SettingsSubAccounts,
        meta: {
          permission: [1, 6, 15, 16],
          path: 'connected-accounts',
          name: 'connected-accounts',
        },
      },
      {
        path: '/settings/streams',
        component: SettingsStreams,
        meta: {
          permission: [1, 6, 15, 16],
          path: 'streams',
          name: 'streams',
        },
      },
      {
        path: '/settings/liveshopping',
        component: SettingsLiveshopping,
        meta: {
          permission: [1, 6, 15, 16],
          path: 'liveshopping',
          name: 'liveshopping',
        },
      },
      {
        path: '/settings/payout',
        component: SettingsPayout,
        meta: {
          permission: [1, 6, 15, 16],
          path: 'payout',
          name: 'payout',
        },
      },
      {
        path: '/settings/plan',
        component: SettingsPlan,
        meta: {
          permission: [1, 6, 15, 16],
          path: 'plan',
          name: 'plan',
          condition: {
            value: 'activeSubscription',
            is: false,
          },
        },
      },
      {
        path: '/settings/billing/:status?',
        component: SettingsBilling,
        meta: {
          permission: [1, 6, 15, 16],
          path: 'billing',
          name: 'billing',
          condition: {
            value: 'activeSubscription',
            is: true,
          },
        },
      },
    ],
  },
  /**
   * Oauth2 callbacks
   */
  {
    path: '/settings/liveshopping/oauth/shopify',
    name: 'oauth-shopify',
    component: OauthShopify,
    meta: {
      permission: [1, 6, 15, 16],
      private: true,
      name: 'settings',
    },
  },
  {
    path: '/settings/liveshopping/oauth/shopline',
    name: 'oauth-shopify',
    component: OauthShopline,
    meta: {
      permission: [1, 6, 16],
      private: true,
      name: 'shopline',
    },
  },
  {
    path: '/settings/liveshopping/oauth/shopline/consent',
    name: 'oauth-shopify',
    component: OauthShoplineConsent,
    meta: {
      permission: [1, 6, 16],
      private: true,
      name: 'shopline-consent',
    },
  },
  /**
   * Developer
   */
  {
    path: '/developer',
    name: 'developer',
    meta: {
      private: true,
      permission: [1, 6, 15, 16],
      name: 'developer',
      menu: {
        i18n: 'developer.title',
        icon: 'code-24',
        highlight: ['developer', 'developer-docs', 'developer-logs'],
        primary: false,
        order: 4,
        items: [
          {
            permission: [1, 6, 15, 16],
            to: '/developer',
            i18n: 'developer.docs',
            highlight: ['developer'],
          },
          {
            permission: [1, 6, 15, 16],
            to: '/developer/logs',
            i18n: 'developer.logs',
            highlight: ['developer-logs'],
          },
        ],
      },
    },
    component: Developer,
  },
  {
    path: '/developer/logs',
    name: 'developer-logs',
    meta: {
      private: true,
      permission: [1, 6, 15, 16],
      name: 'developer-logs',
    },
    component: DeveloperLogs,
  },
  {
    path: '/developer/logs/:id',
    name: 'developerlog',
    props: true,
    meta: {
      private: true,
      permission: [1, 6, 15, 16],
      name: 'developer-logs',
    },
    component: DeveloperLog,
  },
];

const router = new Router({
  mode: 'history',
  routes,
});

// eslint-disable-next-line
router.beforeEach((to, from, next) => {
  const isPrivate = to.matched.some(record => record.meta.private);
  const loggedIn = store.getters['User/token'];
  if (isPrivate && !loggedIn) {
    return next({ path: '/login', query: { redirect: to.fullPath } });
    // eslint-disable-next-line
  } else if (!isPrivate && loggedIn) {
    return next({ path: '/dashboard' });
  }

  function checkPermission() {
    const a = store.getters['User/token'];
    const b = store.getters['User/user'];
    const c = store.getters['AccountManager/account'];

    if (a && (!b || !c)) {
      setTimeout(checkPermission, 100);
    } else {
      const permission = store.getters['User/permission'];
      const accountId = c.id;
      const permissionReq = to.matched.some(
        record => record.meta.permission.includes(permission),
      );
      const accountReq = to.matched.some(record => (typeof record.meta.accountId !== 'undefined' ? record.meta.accountId.includes(accountId) : true));
      if (!permissionReq || !accountReq) {
        return next({ path: '/dashboard' });
      }
      return next();
    }

    return false;
  }

  const user = store.getters['User/user'];
  if (loggedIn && !user) {
    checkPermission();
  } else if (loggedIn && user) {
    const permission = store.getters['User/permission'];
    const accountId = store.getters['AccountManager/account'].id;
    const permissionReq = to.matched.some(
      record => record.meta.permission.includes(permission),
    );
    // let accountReq = true;
    const accountReq = to.matched.some(record => (typeof record.meta.accountId !== 'undefined' ? record.meta.accountId.includes(accountId) : true));
    if (!permissionReq || !accountReq) {
      return next({ path: '/dashboard' });
    }
    return next();
  }

  if (!loggedIn) {
    return next();
  }
});

export default router;
